import { AlertCircle, Clock, Eye } from 'lucide-react'
import { IconCheck, IconLoader } from '@tabler/icons-react'
import { LayerUploadStatus } from 'src/types/layer'

export const getStatusIcon = (status: LayerUploadStatus) => {
  switch (status) {
    case LayerUploadStatus.COMPLETED:
      return <IconCheck className="h-5 w-5 text-light-green-500" stroke={2.5} />
    case LayerUploadStatus.ERROR:
      return <AlertCircle className="h-5 w-5 text-red-500" />
    case LayerUploadStatus.UPLOADING:
      return <IconLoader className="h-5 w-5 animate-spin text-light-green-500" />
    case LayerUploadStatus.PROCESSING:
      return <IconLoader className="h-5 w-5 animate-spin text-blue-500" />
    case LayerUploadStatus.NEEDS_REVIEW:
      return <Eye className="h-5 w-5 text-amber-500" />
    default:
      return <Clock className="h-5 w-5 text-gray-600" />
  }
}
